import { useEffect, useState } from "react";
import { doc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import menuItems from "../constants/menuItems";
import Navbar from "../components/Navbar";

const TEXT_LIMIT = 5000;

function KontaktAdm({ userEmail, onLogout, userRole }) {
	const [formValues, setFormValues] = useState({
		name: "",
		street: "",
		postalCode: "",
		city: "",
		phone: "",
		email: "",
		extraInfo: ""
	});
	const [status, setStatus] = useState({ type: "", message: "" });
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		const docRef = doc(db, "contactInfo", "main");
		const unsubscribe = onSnapshot(
			docRef,
			(snapshot) => {
				if (!snapshot.exists()) {
					return;
				}
				const data = snapshot.data();
				setFormValues({
					name: data.name || "",
					street: data.street || "",
					postalCode: data.postalCode || "",
					city: data.city || "",
					phone: data.phone || "",
					email: data.email || "",
					extraInfo: data.extraInfo || ""
				});
			},
			(error) => {
				setStatus({
					type: "error",
					message: error.message || "Nie udalo sie wczytac kontaktu."
				});
			}
		);

		return () => unsubscribe();
	}, []);

	const handleChange = (key) => (event) => {
		const value = event.target.value;
		setFormValues((prev) => ({
			...prev,
			[key]: value
		}));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		setStatus({ type: "", message: "" });

		const tooLong = Object.entries(formValues).find(
			([, value]) => value.length > TEXT_LIMIT
		);
		if (tooLong) {
			setStatus({
				type: "error",
				message: "Maksymalna dlugosc tekstu to 5000 znakow."
			});
			return;
		}

		setSaving(true);
		try {
			await setDoc(
				doc(db, "contactInfo", "main"),
				{
					name: formValues.name,
					street: formValues.street,
					postalCode: formValues.postalCode,
					city: formValues.city,
					phone: formValues.phone,
					email: formValues.email,
					extraInfo: formValues.extraInfo,
					updatedAt: serverTimestamp()
				},
				{ merge: true }
			);
			setStatus({ type: "success", message: "Zapisano dane kontaktowe." });
		} catch (error) {
			setStatus({
				type: "error",
				message: error.message || "Nie udalo sie zapisac danych kontaktowych."
			});
		} finally {
			setSaving(false);
		}
	};

	return (
		<div className="HomeShell">
			<Navbar menuItems={menuItems} onLogout={onLogout} userRole={userRole} />

			<div className="WelcomePanel">
				<p className="Badge">Kontakt</p>
				<h1 className="Title">Dane kontaktowe</h1>
				<p className="Subtitle">Zalogowano jako {userEmail}.</p>

				<form className="Form" onSubmit={handleSubmit}>
					<div className="FormGrid">
						<label className="Field">
							<span className="Label">Nazwa</span>
							<input
								className="Input"
								value={formValues.name}
								onChange={handleChange("name")}
								maxLength={TEXT_LIMIT}
							/>
						</label>
						<label className="Field">
							<span className="Label">Ulica</span>
							<input
								className="Input"
								value={formValues.street}
								onChange={handleChange("street")}
								maxLength={TEXT_LIMIT}
							/>
						</label>
						<label className="Field">
							<span className="Label">Kod pocztowy</span>
							<input
								className="Input"
								value={formValues.postalCode}
								onChange={handleChange("postalCode")}
								maxLength={TEXT_LIMIT}
							/>
						</label>
						<label className="Field">
							<span className="Label">Miasto</span>
							<input
								className="Input"
								value={formValues.city}
								onChange={handleChange("city")}
								maxLength={TEXT_LIMIT}
							/>
						</label>
						<label className="Field">
							<span className="Label">Telefon</span>
							<input
								className="Input"
								value={formValues.phone}
								onChange={handleChange("phone")}
								maxLength={TEXT_LIMIT}
							/>
						</label>
						<label className="Field">
							<span className="Label">Email</span>
							<input
								className="Input"
								type="email"
								value={formValues.email}
								onChange={handleChange("email")}
								maxLength={TEXT_LIMIT}
							/>
						</label>
						<label className="Field FullRow">
							<span className="Label">Dodatkowe informacje</span>
							<textarea
								className="Input TextArea"
								rows="5"
								value={formValues.extraInfo}
								onChange={handleChange("extraInfo")}
								maxLength={TEXT_LIMIT}
							/>
							<span className="Muted">
								{formValues.extraInfo.length}/{TEXT_LIMIT}
							</span>
						</label>
					</div>

					{status.message ? (
						<p className={status.type === "error" ? "Error" : "Success"}>
							{status.message}
						</p>
					) : null}

					<button className="Button" type="submit" disabled={saving}>
						{saving ? "Zapisywanie..." : "Zapisz kontakt"}
					</button>
				</form>
			</div>
		</div>
	);
}

export default KontaktAdm;
